/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-classic-classes */
import EmberObject from '@ember/object';
import { assert } from '@ember/debug';
import { isArray } from '@ember/array';
import { computed } from '@ember/object';
import { contentEditors } from 'embercom/models/data/matching-system/matching-constants';

export default EmberObject.extend({
  headerComponentConfigs: undefined,
  editorPanelConfigs: undefined,
  footerComponentConfigs: undefined,

  init(inputs) {
    this._super(...arguments);
    assert(
      'An array must be passed for the header component configs',
      isArray(inputs.headerComponentConfigs),
    );
    assert(
      'An array must be passed for the editor panel configs',
      isArray(inputs.editorPanelConfigs),
    );
    assert(
      'An array must be passed for the footer component configs',
      isArray(inputs.footerComponentConfigs),
    );

    inputs.headerComponentConfigs.setEach('parentConfiguration', this);
    inputs.editorPanelConfigs.setEach('parentConfiguration', this);
    inputs.footerComponentConfigs.setEach('parentConfiguration', this);

    this.setProperties({
      headerComponentConfigs: inputs.headerComponentConfigs,
      editorPanelConfigs: inputs.editorPanelConfigs,
      footerComponentConfigs: inputs.footerComponentConfigs,
    });
  },

  seriesEditorPanelConfigs: computed('editorPanelConfigs.[]', function () {
    return this.editorPanelConfigs.filter((config) =>
      config.supportedEditors.includes(contentEditors.series),
    );
  }),

  standaloneEditorPanelConfigs: computed('editorPanelConfigs.[]', function () {
    return this.editorPanelConfigs.filter((config) =>
      config.supportedEditors.includes(contentEditors.standalone),
    );
  }),
});
